import { Grid, GridItem, Heading, Text } from '@chakra-ui/react';
import { USAAParameters, USAAParamType } from '@ssar-app/domain';

interface ParametersSummaryProps {
  model: USAAParameters;
}

export const ParametersSummary = (props: ParametersSummaryProps) => {
  const { model } = props;

  return (
    <>
      <Text
        as='span'
        sx={{
          textAlign: 'center',
          fontSize: 16,
          textColor: 'rgb(29, 79, 145)',
        }}
      >
        {model.type} Parameters
      </Text>
      <Heading
        as={'h3'}
        textAlign={'center'}
        color={'#1d4f91'}
        marginTop={2}
        marginBottom={2}
        fontSize={'md'}
        fontFamily={'Roboto'}
        fontWeight={'normal'}
      >
        Mandatory Parameters
      </Heading>
      <Grid templateColumns='repeat(6, 1fr)' gap={2}>
        <GridItem textAlign={'right'}>
          <strong>Run Type:</strong>
        </GridItem>
        <GridItem colSpan={5} marginLeft={1}>
          {model?.runType}
        </GridItem>
        <GridItem textAlign={'right'}>
          <strong>Strategy Type:</strong>
        </GridItem>
        <GridItem colSpan={5} marginLeft={1}>
          {model?.strategy}
        </GridItem>
        <GridItem textAlign={'right'}>
          <strong>SER-Json File Date:</strong>
        </GridItem>
        <GridItem colSpan={5} marginLeft={1}>
          {model?.serJsonDate}
        </GridItem>
        <GridItem textAlign={'right'}>
          <strong>Execution Date:</strong>
        </GridItem>
        <GridItem colSpan={5} marginLeft={1}>
          {model?.executionDate}
        </GridItem>
        <GridItem textAlign={'right'}>
          <strong>Sample Percentage:</strong>
        </GridItem>
        <GridItem colSpan={5} marginLeft={1}>
          {model?.samplePercentage}
        </GridItem>
        {model?.BureauCallIndicator && (
          <>
            <GridItem textAlign={'right'}>
              <strong>BureauCallIndicator:</strong>
            </GridItem>
            <GridItem colSpan={5} marginLeft={1}>
              {model?.BureauCallIndicator}
            </GridItem>
          </>
        )}
      </Grid>
      <br />
      <Heading
        as={'h3'}
        textAlign={'center'}
        color={'#1d4f91'}
        marginTop={2}
        marginBottom={2}
        fontSize={'md'}
        fontFamily={'Roboto'}
        fontWeight={'normal'}
      >
        Optional Parameters
      </Heading>
      <Grid templateColumns='repeat(6, 1fr)' gap={2}>
        <GridItem textAlign={'right'}>
          <strong>Execute strategy on-demand:</strong>
        </GridItem>
        <GridItem colSpan={5} marginLeft={1}>
          {model?.executeOnDemand}
        </GridItem>
        <GridItem textAlign={'right'}>
          <strong>Consolidated Input FileDate:</strong>
        </GridItem>
        <GridItem colSpan={5} marginLeft={1}>
          {model?.consolidatedInputFileDate}
        </GridItem>
        <GridItem textAlign={'right'}>
          <strong>Bureau FileDate:</strong>
        </GridItem>
        <GridItem colSpan={5} marginLeft={1}>
          {model?.bureauFileDate}
        </GridItem>
        <GridItem textAlign={'right'}>
          <strong>Generate artifacts:</strong>
        </GridItem>
        <GridItem colSpan={5} marginLeft={1}>
          {model?.generateArtifacts}
        </GridItem>
        <GridItem textAlign={'right'}>
          <strong>Execute SPC jobs:</strong>
        </GridItem>
        <GridItem colSpan={5} marginLeft={1}>
          {model?.spcFlag}
        </GridItem>
        {model.type === USAAParamType.AccountManagement ? (
          <>
            <GridItem textAlign={'right'}>
              <strong>Validate the ser-json date:</strong>
            </GridItem>
            <GridItem colSpan={5} marginLeft={1}>
              {model?.SerJsonValidate}
            </GridItem>
          </>
        ) : (
          <>
            <GridItem textAlign={'right'}>
              <strong>Trigger MarketSwitch jobs:</strong>
            </GridItem>
            <GridItem colSpan={5} marginLeft={1}>
              {model?.marketSwitchFlag}
            </GridItem>
          </>
        )}
      </Grid>
    </>
  );
};
